function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 21.93c-5.04 0-9.15-4.1-9.15-9.15V10.9c0-.39.32-.7.7-.7.38 0 .7.32.7.7v1.88c0 4.27 3.47 7.74 7.74 7.74s7.74-3.47 7.74-7.74V10.9c0-.39.32-.7.7-.7.38 0 .7.32.7.7v1.88c.02 5.05-4.09 9.15-9.13 9.15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 2C8.64 2 5.9 4.74 5.9 8.1v4.69c0 3.36 2.74 6.1 6.1 6.1 3.36 0 6.1-2.74 6.1-6.1V8.1C18.1 4.74 15.36 2 12 2zm2.18 8.59a.61.61 0 01-.75.43 5.9 5.9 0 00-3.12 0c-.33.09-.66-.1-.75-.43a.61.61 0 01.43-.75c1.23-.34 2.53-.34 3.76 0 .33.09.52.42.43.75zm.85-2.77a.6.6 0 01-.78.36 6.897 6.897 0 00-4.74 0 .61.61 0 01-.79-.36c-.11-.31.05-.66.37-.78 1.8-.65 3.78-.65 5.57 0 .32.12.48.47.37.78z"
})));